import {
  Container,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
} from "@material-ui/core";
import React from "react";
import "./Req.css";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
  formControl: {
    minWidth: 145,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Closed = () => {
  const classes = useStyles();
  const [view, setView] = React.useState("");
  const [values, setValues] = React.useState(0);

  const handleChanges = (event, newValue) => {
    setValues(newValue);
  };

  const handleChange = (event) => {
    setView(event.target.value);
  };
  return (
    <div className="adminTReq">
      <div>
        <Paper className={classes.root} style={{ margin: "20px 0px" }}>
          <Tabs
            value={values}
            onChange={handleChanges}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab label="Accepted" className="tab" />
            <Tab label="Rejected" className="tab" />
          </Tabs>
        </Paper>
      </div>
      <div className="approvalHeading">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">RFQ No</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">Product Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              {" "}
              <h5 className="approvalTitle">Customer Name</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              {" "}
              <h5 className="approvalTitle">Weight</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">Size</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTitle">Ready to load</h5>
              <input
                type="date"
                data-date-inline-picker="true"
                className="approvalInput"
              />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">From</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">To</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">Type</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTitle">Actions</h5>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">#454151</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Food</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">500 Kgs</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">60*40*34</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">01/04/2022</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Dubai</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">FLT</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"View"}>View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">#454151</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Food</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">500 Kgs</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">60*40*34</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">01/04/2022</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Dubai</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">FLT</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"View"}>View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">#454151</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Food</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">500 Kgs</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">60*40*34</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">01/04/2022</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Dubai</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">FLT</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"View"}>View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">#454151</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Food</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">500 Kgs</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">60*40*34</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">01/04/2022</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Dubai</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">FLT</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"View"}>View</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default Closed;
